import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC, useCallback } from 'react';
import { VideoQuantity } from '../models';

type Props = {
  mode: string;
  label: string;
  description?: string;
};

export const ModeCard: FC<Props> = ({ mode, label, description = '' }) => {
  const formik = useFormikContext<VideoQuantity>();

  const changeMode = useCallback(
    (mode: string) => {
      const currentModes = formik.values.mode;
      let newModes: string[] = [];
      if (currentModes.includes(mode)) {
        if (currentModes.length === 1) {
          newModes = [...currentModes];
        } else {
          newModes = currentModes.filter(m => m !== mode);
        }
      } else {
        newModes = currentModes.concat([mode]);
      }
      formik.setFieldValue('mode', newModes);
    },
    [formik],
  );

  return (
    <Card>
      <CardActionArea
        onClick={() => changeMode(mode)}
        data-active={formik.values.mode.includes(mode) ? '' : undefined}
        sx={{
          height: '100%',
          '&[data-active]': {
            backgroundColor: 'action.selected',
            borderColor: 'secondary.main',
            borderWidth: '2px',
            borderStyle: 'solid',
            '&:hover': {
              backgroundColor: 'action.selectedHover',
            },
          },
        }}
      >
        <CardContent sx={{ height: '100%' }}>
          <Typography variant="h4" component="div">
            {label}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
